import { render, staticRenderFns } from "./OptionPosition.vue?vue&type=template&id=0fd12371&scoped=true"
import script from "./OptionPosition.vue?vue&type=script&lang=js"
export * from "./OptionPosition.vue?vue&type=script&lang=js"
import style0 from "./OptionPosition.vue?vue&type=style&index=0&id=0fd12371&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd12371",
  null
  
)

export default component.exports